import React from "react";
import Svg from "../Svg/Svg";
import { SvgProps } from "../Svg/types";

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 349.96864 469.42577" {...props}>
     <path d="M343.64029,612.73028a17.22226,17.22226,0,0,0,17.18907,17.18906h51.56718v34.37812h34.37813V629.91934H549.909v34.37812h34.37812V629.91934h51.56719a17.22226,17.22226,0,0,0,17.18906-17.18906V561.16309a17.85947,17.85947,0,0,0-4.96871-12.22035l-63.78754-63.78753V526.785H549.909V406.46153c0-77.14934-39.34684-99.03854-43.84554-101.25432a16.53559,16.53559,0,0,0-15.4433,0c-4.4987,2.21578-43.84553,24.105-43.84553,101.25432V526.785H412.39654V485.15521L348.609,548.94274a17.85948,17.85948,0,0,0-4.96872,12.22035Z" transform="translate(-325.57323 -303.29359)"/>
    </Svg>
  );
};

export default Icon;
